import { Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css']
})
export class SearchComponent implements OnInit {
  searchType: any;
  businessAdsInfo:any;

  constructor(private route: ActivatedRoute,) { }
  
  //For child(search-list.component.ts)-to-parent(search.component.ts)-communication 
	toggleClass: boolean = true;
  eventHandler($event:any) {
    this.toggleClass = $event;
  }
  
  filterEvent(){
    this.toggleClass = !this.toggleClass;    
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.searchType = params['type'];
    });
  }
}
